import { CommonModule, PlatformLocation } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';

@Component({
  selector: 'app-first-day-hero',
  templateUrl: './first-day-hero.component.html',
  styleUrls: ['./first-day-hero.component.scss']
})
export class FirstDayHeroComponent implements OnInit {
  @Input() height: number;
  backgroundImage: string;

  constructor(private platformLocation: PlatformLocation, private featureSettingsStoreService: FeatureSettingsStoreService) { }

  ngOnInit() {
    if (this.featureSettingsStoreService.state.firstDayBackgroundImage) {
      this.backgroundImage = `url(${this.platformLocation.getBaseHrefFromDOM()}${this.featureSettingsStoreService.state.firstDayBackgroundImage})`;
    }
  }

}
@NgModule({
  declarations: [FirstDayHeroComponent],
  imports: [
    CommonModule
  ],
  exports: [FirstDayHeroComponent]
})
export class FirstDayHeroModule { }
